import { Card, CardContent, Typography, Button, Stack } from '@mui/material';

export default function InsightCard({ icon, title, insight, action }) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6">
            {icon} {title}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {insight}
          </Typography>

          {action && (
            <Button size="small" variant="contained">
              {action}
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
